import { Assets } from "src/utils/assets";

export function MainLogo() {
    return <div className="logobox text-center"><img src={Assets.mainLogo} alt="Liex" height={220} /><div className="text-center client-name">歯科医院</div></div>
}